<div class="flex h-dvh w-full flex-col overflow-hidden bg-white">
  <header
    id="main-header"
    class="fixed inset-x-0 top-0 z-[90] flex h-16 items-center justify-between gap-2 border-b border-brand-primary-lighter bg-white px-3 lg:gap-3 lg:px-6"
  >
    <div class="flex h-full shrink-0 sm:min-w-0 sm:flex-1">
      <div
        class="flex shrink-0 items-center border-r border-brand-primary-lighter pr-3"
      >
        <a routerLink="/">
          <img
            src="assets/images/my-world-logo.webp"
            alt="Logo Meu Mundo"
            class="w-28 object-contain"
          />
        </a>
      </div>
      <div class="mb-2 mt-3 min-w-0 flex-1 max-sm:hidden">
        <mw-navigation-menu />
      </div>
    </div>

    <div class="flex min-w-0 flex-1 items-center justify-end gap-2 lg:gap-4">
      @if (!isSettingsRoute()) {
        <mw-topbar-filter class="min-w-0 flex-1 sm:flex-none" />

        @let pendingIssuesCount = pendingIssues().result?.length || 0;

        <button
          class="group relative flex size-9 rounded-full transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary-light focus-visible:ring-offset-2 enabled:hover:bg-brand-primary-lightest"
          (click)="handlePendingIssuesNotification()"
        >
          <span
            class="pointer-events-none absolute -right-1 -top-1 flex size-5 select-none items-center justify-center rounded-full bg-feedback-warning-pure text-xs/none text-white transition-all duration-150"
            [class.scale-50]="pendingIssuesCount === 0"
            [class.opacity-0]="pendingIssuesCount === 0"
            [class.scale-100]="pendingIssuesCount > 0"
            [class.opacity-100]="pendingIssuesCount > 0"
          >
            {{ pendingIssuesCount > 99 ? '99+' : pendingIssuesCount }}
          </span>
          <ng-icon
            name="lucideCircleAlert"
            class="m-auto text-brand-primary-pure"
            size="26"
          />
          <span class="sr-only">Notificações de pendências</span>
        </button>
      }

      <ui-dropdown [items]="profileMenu()" size="lg">
        <ng-template #dropdownTrigger let-toggleExpanded="toggleExpanded">
          <button
            type="button"
            class="flex items-center rounded-full text-sm transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-brand-primary-light focus:ring-offset-2"
            id="user-menu-button"
            aria-expanded="false"
            aria-haspopup="true"
            (click)="toggleExpanded()"
          >
            <span class="sr-only">Open user menu</span>
            <ui-avatar [name]="username()" />
          </button>
        </ng-template>
      </ui-dropdown>
    </div>
  </header>

  <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden pt-16">
    @if (breadcrumbs().length > 0) {
      <div class="w-full px-4 py-4 lg:px-6">
        <mw-breadcrumb [breadcrumbs]="breadcrumbs()" />
      </div>
    }

    <router-outlet />
  </div>

  <div
    class="sticky bottom-0 z-50 border-t border-brand-primary-lighter bg-white py-2 pb-4 shadow-sm sm:hidden"
  >
    <mw-navigation-menu />
  </div>
</div>
